module.exports = __webpack_public_path__ + "assets/cover_no-connection.jpg";